import React, { useState, useRef, useEffect } from "react";
import swal from "sweetalert";
import { useDetail, useDelete, useQuery } from "seed/gql";
import { usePost } from "seed/api";
import { SET_COLLECTION } from "seed/gql/queries";
import { Loading } from "seed/helpers";
import l from "components/util/l";
import View from "components/collections/forms/CollectionFormView.view";

function CollectionFormEdit({ 
  flow, 
  collectionId, 
  setActiveCollectionId = () => {},
  onSet = () => {},
  closeModal = () => {},
}) {

  const userId = sessionStorage.getItem("id");
  const formRef = useRef(null);
  const [error, setError] = useState(null);

  const [isPermissionsShown, setIsPermissionsShown] = useState(false);

  const reqCollection = useDetail(`{
    collection {
      name
      schema
      type
      settings
      uiSettings
    }
  }`, collectionId);

  const [callSet, reqSet] = usePost("/collections/update_collection", {
    onCompleted: (data) => {
      onSet();
      closeModal();
    },
    onError: (error) => {
      if(error.status == 409) setError(l("Ya existe una tabla con ese identificador%CA015"))
      else setError(l("Ocurrió un error al crear la tabla%CA016"));
    }
  });

  const [callDelete] = useDelete(SET_COLLECTION, {
		onCompleted: (data) => {
      onSet();
      closeModal();
      setActiveCollectionId(null);
		}
	});

  const reqCollections = useQuery(`{
		collections {
			name
      uiSettings
      flow {
        name
      }
		}
	}`, `(flow.user.id=${flow?.user?.id} AND is_active=true AND flow.is_active=true AND flow.is_current_version=true)`);

  const onDelete = () => {
    swal({
      title: l("Eliminar tabla%CA017"),
      icon: "warning",
      text: l("¿Estás seguro que desea eliminar esta tabla?%CA018"),
      buttons: {
        delete: {
          text: l("Eliminar%GA001"),
          className: "swal-button swal-button--cancel btn-danger px-2 w-100",
        },
        exit: {
          text: l("Cancelar%GA009"),
          className: "swal-button swal-button--cancel btn-secondary px-2 w-100",
        }
      },
    }).then((response) => {
      if(response == "delete") {
        callDelete({ id: collectionId, isActive: false });
      }
    });
  }

  const onSubmit = (values) => {

    delete values.id;
    delete values.schema;
    let structure = values.structure;

    callSet({
      ...values,
      flow_id: flow.id,
      user_id: parseInt(userId),
      collection_id: collectionId,
      structure,
    });

  }

  useEffect(() => {
    reqCollection.refetch();
    reqCollections.refetch();
  }, [flow]);

  if (reqCollection.loading) return <Loading />;
  if (reqCollection.error) return "Error";

  const { collection = {} } = reqCollection.data || {};
  const { collections = [] } = reqCollections.data || {};
  let structure = collection?.schema?.structure || [];
  structure = structure.map((s) => ({
    initial: s,
    final: s,
    internal: s.internal,
    action: "none"
  }));

  let primaryKey = collection?.schema?.primary_key || null;

  return <View
    formRef={formRef}
    flow={flow}
    collectionId={collectionId}
    error={error}
    isLoading={reqSet.loading}
    collection={collection}
    collections={collections}
    collectionType={collection.type}
    initialColumns={structure}
    initialPrimaryKey={primaryKey}
    isPermissionsShown={isPermissionsShown}
    setIsPermissionsShown={setIsPermissionsShown}
    onSubmit={onSubmit}
    onDelete={onDelete}
  />;

}

export default CollectionFormEdit;